import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MaskLines, Reveal } from "../motion/Reveal.jsx";

export default function CTABanner({ eyebrow = "Oneiros Sports Club", lines, copy, primary, secondary, testId = "cta-banner" }) {
  return (
    <section data-testid={testId} className="grain relative overflow-hidden bg-navy px-6 py-24 text-white md:py-32 lg:px-12">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full opacity-30"
        style={{ background: "radial-gradient(circle, rgba(240,86,29,0.5) 0%, transparent 65%)" }}
      />
      <div className="relative z-10 mx-auto flex max-w-5xl flex-col items-center gap-8 text-center">
        <Reveal>
          <p className="eyebrow flex items-center justify-center gap-3">
            <span className="inline-block h-[2px] w-8 bg-brand" />
            {eyebrow}
            <span className="inline-block h-[2px] w-8 bg-brand" />
          </p>
        </Reveal>
        <MaskLines
          lines={lines}
          className="font-display text-4xl leading-[1.05] text-white sm:text-6xl lg:text-7xl"
        />
        {copy && (
          <Reveal delay={0.15}>
            <p className="max-w-xl text-base leading-relaxed text-white/70 md:text-lg">{copy}</p>
          </Reveal>
        )}
        <Reveal delay={0.25} className="flex flex-col items-center gap-4 sm:flex-row">
          {primary && (
            <Link
              data-testid={`${testId}-primary-btn`}
              to={primary.to}
              className="group inline-flex items-center gap-3 rounded-full bg-brand px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-brand-dark"
            >
              {primary.label}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          )}
          {secondary && (
            <Link
              data-testid={`${testId}-secondary-btn`}
              to={secondary.to}
              className="inline-flex items-center gap-3 rounded-full border border-white/30 px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:border-white hover:bg-white hover:text-navy"
            >
              {secondary.label}
            </Link>
          )}
        </Reveal>
      </div>
    </section>
  );
}
